<div class="box-container">
  <mat-icon svgIcon="box-icon" class="icon left-box"></mat-icon>
  <mat-icon svgIcon="box-icon" class="icon right-box"></mat-icon>
  <mat-icon svgIcon="box-filled-icon" class="icon top-box"></mat-icon>
  <span class="item-count">{{ count }}</span>
</div>
